import { render, staticRenderFns } from "./symposiumadd.vue?vue&type=template&id=90be9e74&scoped=true&"
import script from "./symposiumadd.vue?vue&type=script&lang=js&"
export * from "./symposiumadd.vue?vue&type=script&lang=js&"
import style0 from "./symposiumadd.vue?vue&type=style&index=0&id=90be9e74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90be9e74",
  null
  
)

component.options.__file = "symposiumadd.vue"
export default component.exports